export function getTopPageUrl() {
  try {
    if (window.top && window.top !== window) {
      return window.top.location.href;
    }
  } catch (e) {
    // cross-origin → fallback
  }
  return window.location.href;
}

export function getSafeSiteUrl(rawUrl, maxLen = 500) {
  try {
    const u = new URL(rawUrl, window.location.href);

    u.hash = "";

    [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
      "fbclid",
      "gclid",
      "gbraid",
      "wbraid",
      "mc_cid",
      "mc_eid",
    ].forEach((param) => u.searchParams.delete(param));

    let result = u.toString();

    if (result.length <= maxLen) {
      return result;
    }

    u.search = "";
    result = u.toString();

    if (result.length <= maxLen) {
      return result;
    }

    // Last resort: origin only, but this should be rare.
    return u.origin;
  } catch {
    return "";
  }
}